import { resizeImage } from '@hungryroot/image';

type ProductCardImagePropsBase = {
  testid?: string;
  alt: string;
  className: string;
  draggable?: boolean;
};

type ProductCardImagePropsWithSrc = ProductCardImagePropsBase & {
  src: string;
  relativeSrc?: never;
};

type ProductCardImagePropsWithRelativeSrc = ProductCardImagePropsBase & {
  src?: never;
  relativeSrc: string;
};

type ProductCardImageProps =
  | ProductCardImagePropsWithSrc
  | ProductCardImagePropsWithRelativeSrc;

export function ProductCardImage({
  className,
  alt,
  testid,
  src,
  relativeSrc,
  draggable,
}: ProductCardImageProps) {
  return (
    <img
      data-testid={`${testid}-image`}
      {...(src
        ? resizeImage({
            src,
            width: 300,
          })
        : { src: relativeSrc, loading: 'lazy', decoding: 'async' })}
      alt={alt}
      className={className}
      draggable={draggable}
    />
  );
}
